import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, Navigate, RouterProvider, useLocation } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider, useAuth } from './context/AuthContext'
import { CartProvider } from './context/CartContext'
import { ConsoleProvider } from './context/ConsoleContext'
import { EditorTabStateProvider } from './context/EditorTabStateContext'
import { ToastProvider } from './context/ToastContext'
import { AuthManager } from './components/Auth/AuthManager'
import App from './App'
import { PlayPage } from './pages/PlayPage'
import { WelcomePage } from './pages/WelcomePage/WelcomePage'
import { DocsPage } from './pages/DocsPage/DocsPage'
import './styles/globals.css'

function EditorApp() {
  return (
    <ConsoleProvider>
      <CartProvider>
        <EditorTabStateProvider>
          <App />
        </EditorTabStateProvider>
      </CartProvider>
    </ConsoleProvider>
  )
}

function PlayApp() {
  return (
    <ConsoleProvider>
      <PlayPage />
    </ConsoleProvider>
  )
}

function RootRedirect() {
  const { user, loading } = useAuth()
  const location = useLocation()
  const state = location.state as { direct?: boolean; view?: string } | null

  if (loading) return null
  // Allow access if logged in OR if navigated here from within the app
  if (user || state?.direct || state?.view) return <EditorApp />
  return <Navigate to="/welcome" replace />
}

const router = createBrowserRouter([
  { path: '/', element: <RootRedirect /> },
  { path: '/welcome', element: <WelcomePage /> },
  { path: '/docs', element: <DocsPage /> },
  { path: '/play/:cartId', element: <PlayApp /> },
])

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element not found')
}

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <AuthManager>
            <RouterProvider router={router} />
          </AuthManager>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
)
